import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ArService } from 'src/app/services/ar.service';

@Component({
  selector: 'app-add-airlines',
  templateUrl: './add-airlines.component.html',
  styleUrls: ['./add-airlines.component.scss']
})
export class AddAirlinesComponent implements OnInit {

  airlineForm:FormGroup;
 // formTitle = '';
  submitted = false;

  constructor(private router:Router,
    private notifier:NotifierService,
    private spinner:NgxSpinnerService,
    private arService:ArService ) { }

  ngOnInit() {
    this.initAddAirlineForm();
  }

  get airlineFormControls(){
    return this.airlineForm.controls;
  }

  onBack(){
    this.router.navigateByUrl("home/airlines");
  }

  initAddAirlineForm() {
    this.airlineForm = new FormGroup({
      airline_Number: new FormControl('', Validators.compose([Validators.required, Validators.pattern('[0-9a-zA-Z]*')])),
      full_Name: new FormControl('', Validators.compose([Validators.required, Validators.pattern('[a-zA-Z ]*')])),    
    });
  }

  onAddAirline(values){
    this.submitted = true;
    this.validateAgency();
    this.airlineForm.markAllAsTouched();
    if(this.airlineForm.invalid){
      return
    }

    var data = {
      airlineNumber : values.airline_Number,
      airlineFullName: values.full_Name,
      active: true
    }                        

    this.spinner.show()
    this.arService.updateAirlineData(data).subscribe(res => {
    //  console.log(res)
      if (res['status']) {
        this.spinner.hide()
        this.submitted = false
        this.notifier.notify('success', res['message']);
        this.initAddAirlineForm();
      } else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
       console.log(err);
    })
    this.router.navigateByUrl("home/airlines");

  }

  validation_messages = {
    'airline_Number': [
      { type: 'required', message: 'Airline Number is required.' },
      { type: 'pattern', message: ' Airline Number must not contain any special characters.' }
    ],
    'full_Name': [
      { type: 'required', message: 'Airline Name is required.' },
      { type: 'pattern', message: ' Airline Name must be alphabets only.' }
    ]
  }

  validateAgency() {
    if (this.airlineFormControls.airline_Number.errors) {
      this.notifier.notify('warning', 'Please enter Airline Number ');
      return false;
    }
    if (this.airlineFormControls.full_Name.errors) {
      this.notifier.notify('warning', 'Please enter Airline Name ');
      return false;
    }
  }

}
